import React, { useState } from 'react';
import grinderClosed from '../assets/store/grinder closed.png';
import grinderOpen from '../assets/store/grinder open.png';
import grinderHalf from '../assets/store/grinder half.png';
import grinderDetail1 from '../assets/store/grinder detail 1.jpeg';
import grinderDetail2 from '../assets/store/grinder detail 2.jpeg';
const ArrowIcon = ({ direction }) => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--ic" width="1em" height="1em" viewBox="0 0 24 24" style={{pointerEvents: "auto"}}>
    <g transform={`rotate(${direction} 12 12)`}>
      <path fill="currentColor" d="M11.29 8.71L6.7 13.3a.996.996 0 1 0 1.41 1.41L12 10.83l3.88 3.88a.996.996 0 1 0 1.41-1.41L12.7 8.71a.996.996 0 0 0-1.41 0z"></path>
    </g>
  </svg>
);

export default function ProductDetail({ product, imageIdx, onImageChange, onClose, onNextProduct, onPrevProduct, detailRef, handleWheel, handleTouchStart, handleTouchEnd }) {
  const [showInfo, setShowInfo] = useState(false);
  const [touchXStart, setTouchXStart] = useState(null);
  const [touchXEnd, setTouchXEnd] = useState(null);
  const handleNextImage = () => onImageChange((prev) => (prev + 1) % product.images.length);
  const handlePrevImage = () => onImageChange((prev) => (prev - 1 + product.images.length) % product.images.length);

  // Horizontal swipe handlers for image navigation
  const onImageTouchStart = (e) => {
    if (e.touches && e.touches.length === 1) {
      setTouchXStart(e.touches[0].clientX);
    }
  };
  const onImageTouchEnd = (e) => {
    if (touchXStart === null) return;
    const xEnd = e.changedTouches[0].clientX;
    const diff = touchXStart - xEnd;
    if (Math.abs(diff) > 40) {
      if (diff > 0) {
        handleNextImage();
      } else {
        handlePrevImage();
      }
    }
    setTouchXStart(null);
  };

  return (
    <div
      className="product-detail"
      ref={detailRef}
      onWheel={handleWheel}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <button className="detail-back" onClick={onClose} aria-label="back">
        <ArrowIcon direction={-90} />
      </button>

      <button className="detail-nav detail-prev" onClick={handlePrevImage} aria-label="previous image">
        <ArrowIcon direction={-90} />
      </button>
      <button className="detail-nav detail-next" onClick={handleNextImage} aria-label="next image">
        <ArrowIcon direction={90} />
      </button>

      <div className="detail-image"
        onTouchStart={onImageTouchStart}
        onTouchEnd={onImageTouchEnd}
      >
        {
          (() => {
            const imageMap = {
              'grinder closed.png': grinderClosed,
              'grinder open.png': grinderOpen,
              'grinder half.png': grinderHalf,
              'grinder detail 1.jpeg': grinderDetail1,
              'grinder detail 2.jpeg': grinderDetail2,
            };
            return (
              <img src={imageMap[product.images[imageIdx]]} alt={`${product.code} - Image ${imageIdx + 1}`} />
            );
          })()
        }
      </div>

      <div className="detail-info">
        {showInfo ? (
          <div style={{padding:'32px 0 24px',textAlign:'center'}}>
            <div className="detail-info-content">{product.info}</div>
            <button
              style={{display:'block',margin:'24px auto 0 auto',fontSize:24,border:0,background:'none',cursor:'pointer',color:'#111',lineHeight:1,padding:'4px'}}
              aria-label="close info"
              onClick={() => setShowInfo(false)}
            >×</button>
          </div>
        ) : (
          <>
            <div className="detail-dots">
              {product.images.map((_, i) => (
                <span key={i} className={`dot ${i === imageIdx ? 'active' : ''}`}>•</span>
              ))}
            </div>
            <div className="detail-code">{product.code}</div>
            <div className="detail-price">£{product.price}</div>
            <button className="detail-info-btn" onClick={() => setShowInfo(true)}>INFORMATION</button>
            <button className="detail-add" aria-label="add to cart" onClick={() => window.open('https://buy.stripe.com/aFa4gAa5Q5H57t48vraAw06', '_blank', 'noopener,noreferrer')}>+</button>
          </>
        )}
      </div>
    </div>
  );
}
